import React, { useEffect, useState } from "react";
import Div100vh from "react-div-100vh";
import { userDataAtom } from "@/recoil/atom/userDataAtom";
import { useRecoilState } from "recoil";

import { updateFunction, trackBtnClick, trackPageView } from "@/lib/helper";
import bgBhai from "@/assets/images/bubbles.jpg";
import Header from "@/components/common/Header/header";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";

const termsAndConditions = [
  "Do not create any nuisance in the surroundings",
  "Clear any pending dues like electricity, maintenance, etc",
  "Deep cleaning of property before vacating",
  "Get the necessary repairs done in case there is any damage to property",
  "Return the property in the same condition as it was handed over to you on move-in",
];

export default function TermsAndConditions({ setOtpDrawer }) {
  const [userData, setUserData] = useRecoilState(userDataAtom);

  const [isLoading, setIsLoading] = useState(false);
  const [touchStartY, setTouchStartY] = useState(null);
  const [touchEndY, setTouchEndY] = useState(null);

  const minSwipeDistanceY = 50;

  const onTouchStart = (e) => {
    setTouchEndY(null);
    setTouchStartY(e.targetTouches[0].clientY);
  };

  const onTouchMove = (e) => {
    setTouchEndY(e.targetTouches[0].clientY);
  };

  const onTouchEnd = () => {
    if (!touchStartY || !touchEndY) return;

    const distanceY = touchStartY - touchEndY;
    const isDownSwipe = distanceY < -minSwipeDistanceY;

    // if (isDownSwipe) setOtpDrawer((prevState) => !prevState);
  };

  const handleClick = async () => {
    setIsLoading((prevState) => !prevState);

    try {
      await updateFunction(
        {
          acceptedTNC: true,
        },
        "user/update"
      );
      setUserData({ ...userData, acceptedTNC: true });
      trackBtnClick("I Accept", "Tenant T&C Screen");
      setOtpDrawer((prevState) => !prevState);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading((prevState) => !prevState);
    }
  };

  useEffect(() => {
    trackPageView("Tenant T&Cs", "Home Page CTA");
  }, []);

  return (
    <Div100vh
      className="flex flex-col bg-[#010101] bg-no-repeat bg-cover py-4 px-6 items-center justify-start gap-8"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(1, 1, 1, 1) 10%, rgba(1, 1, 1, 1) 0% ,rgba(1, 1, 1, 0) 100%), url(${bgBhai})`,
      }}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <div className="w-full">
        <Header
          customBackSubmit={() => setOtpDrawer((prevState) => !prevState)}
        />
      </div>
      <span className="text-xl font-medium">
        As a trustworthy tenant, you are responsible for:
      </span>
      <div className="flex flex-col gap-2">
        {termsAndConditions.map((data, index) => (
          <div
            key={index}
            className="flex flex-col bg-[#444] bg-opacity-30 px-6 p-3 rounded-lg backdrop-blur-2xl border border-[#888]/50"
          >
            <div className="gap-1 flex flex-col">
              {/* <h2 className="text-xs sm:text-lg font-medium">
                {benefit.title}
              </h2> */}
              <p className="text-xs font-light sm:text-normal text-gray-300">
                {data}
              </p>
            </div>
          </div>
        ))}
      </div>
      {!userData?.acceptedTNC && (
        <PrimaryButton
          text="I Accept"
          handleClick={() => handleClick()}
          loading={isLoading}
        />
      )}
    </Div100vh>
  );
}
